import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {WMSContext} from "../../../views/wms/context/WMSContext";
import Popup from "../Mobile/Popup";
import {wmsItemWaitingToBeCancelled} from "../../../api/wms/wmsItems/wmsItems";
import CustomButton from "../../CustomButton";
import {Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";

ToBeCancelledItem.propTypes = {
    item: PropTypes.object.isRequired
};

let alertAudioContext;

// Synthesized instead of an audio file so there's nothing to load/cache before the alert fires.
function playAlertSound() {
    try {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!alertAudioContext) {
            alertAudioContext = new AudioContextClass();
        }
        if (alertAudioContext.state === "suspended") {
            alertAudioContext.resume();
        }

        const oscillator = alertAudioContext.createOscillator();
        const gainNode = alertAudioContext.createGain();

        oscillator.type = "sawtooth";
        gainNode.gain.value = 0.5;

        const now = alertAudioContext.currentTime;
        oscillator.frequency.setValueAtTime(100, now);
        oscillator.frequency.setValueAtTime(0, now + 0.08);
        oscillator.frequency.setValueAtTime(100, now + 0.1);

        oscillator.connect(gainNode);
        gainNode.connect(alertAudioContext.destination);

        oscillator.start(now);
        oscillator.stop(now + 0.25);
    } catch (e) {
    }
}

function ToBeCancelledItem({item, open, handleClose}) {
    const {currentInventory} = useContext(WMSContext)

    const [loading, setLoading] = useState(false)

    if (!item.toBeCancelled) {
        return
    }

    useEffect(() => {
        if (open) {
            playAlertSound();
        }
    }, [open]);

    const handleValid = () => {
        if (null === currentInventory) {
            return
        }

        setLoading(true)

        wmsItemWaitingToBeCancelled(item.id).then(() => {
            handleClose(true)
        }).catch(error => {
            setLoading(false)
        })
    }
    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.toBeCancelled.title"}/>}
            subtitle={<FormattedMessage id={"wms.toBeCancelled.subtitle"}/>}
            hideCloseIcon
            strictOnclose
        >
            <Grid container direction={"column"} gap={2}>
                <CustomButton
                    loading={loading}
                    onClick={() => handleValid()}
                    disabled={loading}
                    fullWidth
                >
                    <FormattedMessage id={"wms.toBeCancelled.valid"}/>
                </CustomButton>
                <CustomButton
                    loading={loading}
                    onClick={() => handleClose(false)}
                    disabled={loading}
                    fullWidth
                    color={"lightRed"}
                >
                    <FormattedMessage id={"wms.toBeCancelled.cancel"}/>
                </CustomButton>
            </Grid>
        </Popup>
    );
}

export default ToBeCancelledItem;